import { call, put } from 'redux-saga/effects';
import { actions } from 'store/loading';
import * as Actions from './actions';
import Api from 'utils/api';
import { CredentialsDto } from 'types';

export function* ensureGetCredentials({
  payload,
}: {
  payload?: { noLoader?: boolean };
  type: typeof Actions.getCredentials.TRIGGER;
}) {
  const noLoader = payload?.noLoader;
  try {
    if (!noLoader) yield put(actions.tabLoading(true));
    const data: CredentialsDto = yield call(Api.credentials.getCredentials);
    yield put(Actions.getCredentials.success(data));
  } catch (err) {
    yield put(Actions.getCredentials.failure(err));
  } finally {
    if (!noLoader) yield put(actions.tabLoading(false));
  }
}

export function* ensurePatchNetSuiteCredentials({
  payload,
}: {
  payload: Partial<CredentialsDto>;
  type: typeof Actions.patchCredentials.TRIGGER;
}) {
  try {
    const data: CredentialsDto = yield call(
      Api.credentials.patchNetSuiteCredentials,
      payload
    );
    yield put(Actions.patchCredentials.success(data));
  } catch (err) {
    yield put(Actions.patchCredentials.failure(err));
  }
}
